define([
	"dojo/_base/declare",
	"csi/heading/AttributeController"
], function(declare,AttributeController) {

	return declare(AttributeController, {
		toWriter: function() {
			// summary: write request to refresh image thumbnail by passing url to image node
			var	urlOld = this.m_urlNode;

			this.m_urlNode = this.m_action._getImageUrl(this._ctx);
			this.toWriterRequest();
			this.m_urlNode = urlOld;
		}
	});
});